module.exports = __webpack_public_path__ + "static/media/icon.86c2eaae.svg";